import { useCallback, useMemo } from 'react';
import { configureMentionsPlugin } from '../configureMentionsPlugin';
import { processMentions, separateMentions } from '../TeamMentionUtils';
import { useAtMentionOptions } from './useAtMentionOptions';
export function useConfiguredMentionsPlugin(owners, teams, onMentionChange) {
  const {
    allOptions,
    teamOptions
  } = useAtMentionOptions(owners, teams);
  const mentionsPlugins = useMemo(() => configureMentionsPlugin(allOptions, {
    onMentionsChanged: onMentionChange ? currentOptions => onMentionChange(separateMentions(currentOptions)) : undefined
  }), [allOptions, onMentionChange]);
  const processAtMentions = useCallback(mentions => processMentions(mentions, allOptions, teamOptions), [allOptions, teamOptions]);
  return {
    mentionsPlugins,
    processAtMentions
  };
}